import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Training } from 'src/app/models/training.model';
import { AuthService } from '../../services/auth-service/auth.service';
import { LocalStorageService } from '../../services/localStorage-service/local-storage.service';
import { UserLanguageService } from '../../services/user-language-service/user-language.service';
import { UserDashboardService } from '../../user-dashboard.service';
import { UserBeforeTestMessageComponent } from '../../user-training/user-before-test-message/user-before-test-message.component';

@Component({
    selector: 'app-user-confirm-survey-message',
    templateUrl: './user-confirm-survey-message.component.html',
    styleUrls: ['./user-confirm-survey-message.component.scss'],
    standalone: false
})
export class UserConfirmSurveyMessageComponent implements OnInit {

  labelsSub:Subscription
  labels

  langSub:Subscription
  lang

  training$: Observable<Training>
  training: Training
  trainingSub: Subscription

  user
  userSub: Subscription

  button1 = ""
  button2 = ""
  color = ""
  constructor(public dialogRef: MatDialogRef<UserBeforeTestMessageComponent>,
    private authService: AuthService,
    private userDashboardService: UserDashboardService,
    private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private userLanguageService: UserLanguageService, private localStorageService:LocalStorageService) { }

  ngOnInit(): void {
    this.langSub = this.userLanguageService.lang$.subscribe((lang) =>{
      this.lang = lang;
    })
    this.labelsSub = this.userLanguageService.labels$.subscribe((labels) =>{
      this.labels = labels;
    })

  }

  voidUserResult() {
    /*this.userDashboardService.voidUserTraining(this.data.training._id).subscribe((response) => {
      this.localStorageService.removeItem('currentUnit')
      this.router.navigateByUrl('user/training-details');
    })*/
    this.router.navigateByUrl('user/training-details');

    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if(this.langSub) this.langSub.unsubscribe()
    if(this.labelsSub) this.labelsSub.unsubscribe()
    if(this.trainingSub) this.trainingSub.unsubscribe()
    if(this.userSub) this.userSub.unsubscribe()
  }
}
